// Get all YouTube and Vimeo iframes and wrap them in .video-container
//var videoIframes = Array.from(document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]'));
var videoIframes = Array.from(
	document.querySelectorAll('div:not(.product-description) iframe[src*="youtube.com"], div:not(.product-description) iframe[src*="vimeo.com"]')
);
if (videoIframes.length > 0) {
    // iterate through all iframes
    videoIframes.forEach(iframeItem => {
        // get iframe parent
        var iframeItemParent = iframeItem.parentNode;
        // check if iframe parent is not a .video-container container, wrap iframe in .video-container
        if (!iframeItemParent.classList.contains('video-container')) {
            // create wrapper container
            var videoWrapper = document.createElement('div');
            videoWrapper.classList.add('video-container');
            // insert videoWrapper before iframeItem in the DOM tree
            iframeItemParent.insertBefore(videoWrapper, iframeItem);
            // move iframeItem into videoWrapper
            videoWrapper.appendChild(iframeItem);
        }
    });
}


// Overlays

// cookies
var createCookie = (name, value, days) => {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        var expires = '; expires=' + date.toGMTString();
    } else var expires = '';
    document.cookie = name + '=' + value + expires + '; path=/';
};
var readCookie = name => {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};
var eraseCookie = name => {
    createCookie(name, '', -1);
};

// open, close
function closeOverlay() {
    jQuery('body').removeClass('open-overlay');
    clearInterval(overlayCountdownInterval);
}
function openOverlay() {
    jQuery('body').addClass('open-overlay');
}
jQuery(document).on('click', '#overlay .overlay__close, #overlay .overlay__opt-out', function (event) {
    event.preventDefault();
    closeOverlay();
});

// countdown
var overlayCountdownInterval;
function overlayCountdown(deadline) {
    var countdownClock = jQuery('.overlay__countdown'),
        eventTime = moment(deadline, 'MM/DD/YYYY ha').tz("America/Los_Angeles").unix(),
        currentTime = moment().unix(),
        diffTime = eventTime - currentTime,
        duration = moment.duration(diffTime * 1000, 'milliseconds'),
        interval = 1000;
    // if time to countdown
    if (diffTime > 0) {
        var countdownDays = countdownClock.find('.days'),
            countdownHours = countdownClock.find('.hours'),
            countdownMinutes = countdownClock.find('.minutes'),
            countdownSeconds = countdownClock.find('.seconds');
        overlayCountdownInterval = setInterval(function () {
            duration = moment.duration(duration.asMilliseconds() - interval, 'milliseconds');
            var d = moment.duration(duration).days(),
                h = moment.duration(duration).hours(),
                m = moment.duration(duration).minutes(),
                s = moment.duration(duration).seconds();
            d = jQuery.trim(d).length === 1 ? '0' + d : d;
            h = jQuery.trim(h).length === 1 ? '0' + h : h;
            m = jQuery.trim(m).length === 1 ? '0' + m : m;
            s = jQuery.trim(s).length === 1 ? '0' + s : s;
            // show how many hours, minutes and seconds are left
            countdownDays.text(d);
            countdownHours.text(h);
            countdownMinutes.text(m);
            countdownSeconds.text(s);
            if (m == 0 && s == 0) {
                clearInterval(overlayCountdownInterval);
                console.log('overlayCountdownInterval cleared');
            }
        }, interval);
    }
}

// check for overlays
var overlay = document.getElementById('overlay');
if(overlay){
    var overlayType = overlay.dataset.type;
    var overlayCookie = readCookie(overlayType);
    var deadline = overlay.dataset.deadline;
    // if theres no cookie
    if (!overlayCookie) {
        // show overlay after a brief delay
        setTimeout(function () {
            // set cookie, expires in one day
            createCookie(overlayType, 'set', 1);            
            // setup countdown
            if( deadline ){
                overlayCountdown(deadline);
            }
            // open overlay
            openOverlay();
        }, 4000);
    }
}

// resets viewport meta to prevent android keyboard pushing up layout
function resetViewportMeta() {
    var viewheight = window.innerHeight;
    var viewwidth = window.window.innerWidth;
    var viewport = document.querySelector('meta[name=viewport]');
    viewport.setAttribute(
        'content',
        'height=' + viewheight + 'px, width=' + viewwidth + 'px, initial-scale=1.0'
    );
}
var userAgent = navigator.userAgent.toLowerCase();
var isAndroid = userAgent.indexOf("android") > -1; //&& ua.indexOf("mobile");
if(isAndroid) {
    setTimeout(function () {
        resetViewportMeta();
    }, 300);
}

// Registry APP
var findRegistryAppInterval;
var findRegistryAppIntervalRound = 0;
var registryApp;
if(document.body.classList.contains('app-giftregistry')) {        
    findRegistryAppInterval = setInterval(function(){
        findRegistryApp(findRegistryAppIntervalRound);       
        findRegistryAppIntervalRound ++; 
    },500);
}
function findRegistryApp(intervalRound) {
    if(intervalRound == 10){
        clearInterval(findRegistryAppInterval);
    }
    registryApp = jQuery('.giftreggie-front').first();
    if( registryApp.length > 0){
        clearInterval(findRegistryAppInterval);
        setRequiredFields(registryApp);
        addRegistryShippingLanguage();
    }
}
function setRequiredFields(appElement) {
    var requiredFieldNames = ['registry-title','event-date','contact-address','contact-city','contact-postal'];
    var registryForm = jQuery('#giftreggie-create-form, #giftreggie-update-form').first();
    if(registryForm.length > 0){
        requiredFieldNames.forEach(function(fieldName){        
            registryForm.find('input[name="'+fieldName+'"]').before('<em class="required">*</em>');
        });
    }
}
function addRegistryShippingLanguage(){
    var registryPageHeader = document.querySelector('.giftreggie-registry > .giftreggie-header');
    if(registryPageHeader){
        registryPageHeader.classList.add('here-it-is');
        registryPageHeader.innerHTML += `<div class="giftreggie-header-notice">Gift Registry guests get <i><strong>free shipping</strong></i> with code REGISTRY <i>*valid for one use</i></div>`;
    }
}


// Free Shipping Notice for US
var checkIpErrors = 0;
function checkIp() {
    // get client IP
    jQuery.ajax({
        url: 'https://www.cloudflare.com/cdn-cgi/trace',
        error: function (err) {
            console.log('cloudflare ip error:' + JSON.stringify(err));
            // try again just once
            if( checkIpErrors == 0){
                checkIpErrors ++;
                checkIp();
            }
        },
        success: function (data) {
            var locationRegex = /loc=\D{2}/;
            customerCountryCode = data.match(locationRegex)[0].replace('loc=','');
            if( customerCountryCode == "US"){
                jQuery('.free-shipping-notice').addClass('active');
            }
        }
    });
}

if (jQuery('.template-cart').length > 0) {
    checkIp();
}